import { render } from "./MITransactions.vue?vue&type=template&id=f9e2be62"
import script from "./MITransactions.vue?vue&type=script&lang=js"
export * from "./MITransactions.vue?vue&type=script&lang=js"
script.render = render

export default script